import type { FileUploadItem } from '@gov-nx/core/hooks';
import { FileState } from '@gov-nx/core/hooks';

export const isAllUploaded = (files: FileUploadItem[]) =>
	files.every(
		(file) => file.state === FileState.success || file.state === FileState.error
	);
